import { useEffect } from "react";

import { captureCampaignAttribution } from "../utils/campaignAttribution";
import { mixpanel } from "../utils";

const useCampaignSessionTracking = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return;

    const attribution = captureCampaignAttribution();
    if (attribution) {
      mixpanel.registerCampaignAttribution(attribution);
    }
  }, [enabled]);
};

export default useCampaignSessionTracking;
